//# sourceMappingURL=bool_.mjs.map
/// <reference types="./bool_.d.mts" />
/**
 * Acts as `bool.or`, but run the second argument only if the first argument
 * is `False`. Acts as `||`.
 *
 * ```gleam
 * bool_.lazy_or(False, fn () -> True)  // True
 * bool_.lazy_or(True,  fn () -> False) // True
 * bool_.lazy_or(True,  fn () -> True)  // True
 * bool_.lazy_or(False, fn () -> False) // False
 *
 * // Or use it with `use`.
 * use <- bool_.lazy_or(False)
 * echo "Computation when argument is False"
 * True
 * ```
 */
export function lazy_or(data, next) {
  if (data) {
    return data;
  } else {
    return next();
  }
}

/**
 * Acts as `bool.and`, but run the second argument only if the first argument
 * is `True`. Acts as `&&`.
 *
 * ```gleam
 * bool_.lazy_and(False, fn () -> True)  // False
 * bool_.lazy_and(True,  fn () -> False) // False
 * bool_.lazy_and(True,  fn () -> True)  // True
 * bool_.lazy_and(False, fn () -> False) // False
 *
 * // Or use it with `use`.
 * use <- bool_.lazy_and(True)
 * echo "Computation when argument is True"
 * True
 * ```
 */
export function lazy_and(data, next) {
  if (data) {
    return next();
  } else {
    return data;
  }
}

/**
 * Returns `then` when the condition is `True`, `otherwise` when it is `False`.
 * Emulates ternary expressions (inline if-else) found in other languages.
 *
 * ```gleam
 * bool_.choose(when: True,  then: "cat", otherwise: "dog") // "cat"
 * bool_.choose(when: False, then: "cat", otherwise: "dog") // "dog"
 * ```
 */
export function choose(when, then$, otherwise) {
  if (when) {
    return then$;
  } else {
    return otherwise;
  }
}
